import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actions: 'Actions',
    subtitle: 'You can lock this card to prevent fraudulent uses.',
    title: 'Did something happen?',
  },
  fr: {
    actions: 'Actions',
    subtitle:
      'Vous pouvez bloquer cette carte pour éviter tout débit frauduleux.',
    title: 'Il y a un problème ?',
  },
} as const);

export default locales;
